import { render, staticRenderFns } from "./retail_room_card.vue?vue&type=template&id=6b1e41f4&"
import script from "./retail_room_card.vue?vue&type=script&lang=js&"
export * from "./retail_room_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports